(function () {

    "use strict";
    angular.module("harriApp")
        .directive('hmapLayoutHeader', ["$q", "hTransitions", "$stateParams", "$state", "hUser", "talentPoolDataService", "brandServices", "hmapService", "userServices", "userPermissions", "interviewBankDataService", "useScheduledExportsFactory", function ($q, hTransitions, $stateParams, $state, hUser, talentPoolDataService, brandServices, hmapService, userServices, userPermissions, interviewBankDataService, useScheduledExportsFactory) {
            return {
                restrict: "E",
                scope: {},
                templateUrl: '../modules/hmap/hmap_layout_header/hmap_layout_header.ng.html',
                link: function ($scope, formElement, attrs) {

                    //TODO: migration
                    var dashboardState = "appLayout.harriSH.access-portal.main";
                    var activeBrandId = hmapService.getActiveBrand();

                    $scope.activeBrandId = activeBrandId;
                    $scope.brands = hmapService.brands;
                    $scope.breadcrumbs = [];
                    $scope.activeBrandPolicy = {};
                    $scope.activeView = null;
                    $scope.permissions = {};
                    $scope.systemPermisions = userPermissions.PERMISSIONS;
                    $scope.templateTrackAutomation = '';
                    $scope.reportsExporterTitle = $filter("translate")('Reports exporter');
                    var activeHmapPath = '';

                    hmapService.onActiveBrandChanged(function (brand) {
                        $scope.brands = hmapService.brands;

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    });

                    $scope.getHmapPath = function () {
                        return $stateParams.hmapPath || activeHmapPath;
                    };

                    var loadPermissions = function () {
                        var defer = $q.defer();

                        userPermissions.getBrandPolicy(activeBrandId)
                            .then(function (policyParser) {

                                $scope.permissions['canManageBrandDetails'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BRAND_DETAILS);
                                $scope.permissions['canManageBrandMedia'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_MEDIA);

                                $scope.permissions['canManageJobTemplates'] = policyParser.has(userPermissions.PERMISSIONS.CREATE_EDIT_JOB_POST);
                                $scope.permissions['canManageOfferTemplates'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_OFFER_TEMPLATES);
                                $scope.permissions['canManageHrActionsTemplates'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_HR_ACTIONS_TEMPLATES);
                                $scope.permissions['canManageManagersNotificationsTemplates'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_NOTIFICATIONS);
                                $scope.permissions['canManageInterviewQuestionsBank'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_QUESTIONS_AND_TEMPLATES_BANK);
                                $scope.permissions['canManageRoles'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_ROLES_GROUPS);

                                $scope.permissions['canManageUsers'] = policyParser.hasAny([userPermissions.PERMISSIONS.ADD_USERS, userPermissions.PERMISSIONS.MANAGE_ROLES_GROUPS]);

                                $scope.permissions['canViewGroupManagement'] = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_USERS_IN_GROUPS, userPermissions.PERMISSIONS.MANAGE_ROLES_GROUPS]);

                                $scope.permissions['hasAccessToSourceHire'] = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
                                $scope.permissions['hasAccessToTeam'] = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                                $scope.permissions['canManageOnBoardingJourneyTemplates'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_ON_BOARDING_JOURNEY_EVENTS);

                                $scope.permissions['canManageCRM'] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_CRM);
                                defer.resolve();
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                        return defer.promise;
                    };

                    //Evaluate breadcrumbs
                    var evalutePath = function (hmapPath, urlParts) {
                        $scope.breadcrumbs = [];

                        var brandId = hUser.getUserContext().brand_id;

                        hmapService.loadBrand(brandId);

                        $scope.breadcrumbs.push(
                            {
                                type: "BRAND",
                                id: brandId,
                                active: urlParts.length === 0,
                                href: $state.href(dashboardState, { hmapPath: "" })
                            }
                        );

                        var nestedBrandsList = [];

                        for (var i in urlParts) {

                            var nestedBrandId = parseInt(urlParts[i]);
                            nestedBrandsList.push(nestedBrandId);

                            hmapService.loadBrand(nestedBrandId);

                            var url = nestedBrandsList.join("-");
                            $scope.breadcrumbs.push(
                                {
                                    type: "BRAND",
                                    id: urlParts[i],
                                    url: url,
                                    href: $state.href(dashboardState, { hmapPath: url}),
                                    active: (parseInt(i) === urlParts.length - 1),
                                }
                            );

                            if ($state.current.name === dashboardState) {
                                $scope.activeView = "DASHBOARD_" + nestedBrandId;
                            }
                        }

                        let tabId = '';

                        switch ($state.current.name) {
                            case "appLayout.harriSH.access-portal.user-management":
                            case "appLayout.harriSH.add-user-management":
                                $scope.activeView = "USER_MANAGEMENT";
                                break;

                            case "appLayout.harriSH.access-portal.jobs":
                                $scope.activeView = "MY_JOBS";
                                break;

                            case "appLayout.harriSH.access-portal.reports":
                                $scope.activeView = "RAW_DATA_REPORTING";
                                tabId = 'RAW_DATA_REPORTING';

                                brandServices.check(brandServices.SERVICES.SCHEDULE_REPORTS, $scope.activeBrandId)
                                    .then((isScheduledExportEnabled) => {
                                        if (isScheduledExportEnabled) {
                                            $scope.reportsExporterTitle = $filter("translate")('Automated report scheduler');
                                            $scope.$digest();
                                        }
                                    });
                                break;

                            case "appLayout.harriSH.access-portal.atrs-listings":
                                $scope.activeView = "ATRS_LISTINGS";
                                break;

                            case "appLayout.harriSH.access-portal.atrs-manage":
                                $scope.activeView = "ATRS_MANAGE";
                                break;
                            case "appLayout.harriSH.access-portal.job-approvals":
                                $scope.activeView = "JOB_APPROVALS_LISTINGS";
                                break;

                            case "appLayout.harriSH.access-portal.manage-permissions":
                            case "appLayout.harriSH.group-permission":
                            case "appLayout.harriSH.user-group-permission":
                                $scope.activeView = "MANAGE_PERMISSIONS";
                                break;

                            case "appLayout.harriSH.access-portal.interview-question-new":
                            case "appLayout.harriSH.access-portal.interview-question-edit":
                            case "appLayout.harriSH.access-portal.interview-template-new":
                            case "appLayout.harriSH.access-portal.interview-template-edit":
                            case "appLayout.harriSH.access-portal.video-interview-types":
                            case "appLayout.harriSH.access-portal.video-interview-media":
                            case "appLayout.harriSH.access-portal.video-interview-question-new":
                            case "appLayout.harriSH.access-portal.video-interview-question-edit":
                            case "appLayout.harriSH.access-portal.video-interview-template-new":
                            case "appLayout.harriSH.access-portal.video-interview-template-edit":
                            case "appLayout.harriSH.access-portal.interview-questions-bank":
                            case "appLayout.harriSH.access-portal.interview-questions-types":
                            case "appLayout.harriSH.access-portal.video-interview-questions":
                            case "appLayout.harriSH.access-portal.interview-questions-templates":
                            case "appLayout.harriSH.access-portal.video-interview-templates":
                                $scope.activeView = "INTER_VIEW_QUESTIONS_BANK";
                                break;

                            case "appLayout.harriSH.access-portal.pay-runs":
                                $scope.activeView = "PAY_RUNS";
                                break;

                            case "appLayout.harriSH.access-portal.settings.main":
                            case "appLayout.harriSH.access-portal.custom-document-wizard":
                            case "appLayout.harriSH.offerTemplates.create":
                            case "appLayout.harriSH.access-portal.break-waivers":
                            case "appLayout.harriSH.access-portal.settings.offerTemplates.create":
                                $scope.activeView = "SETTINGS";
                                break;

                            case "appLayout.harriSH.access-portal.settings.jobTemplates":
                            case "appLayout.harriSH.access-portal.settings.job_create_edit":
                            case "appLayout.harriSH.access-portal.settings.job_create_new":
                            case "appLayout.harriSH.access-portal.create-screening-questions":
                            case "appLayout.harriSH.access-portal.settings.hrActionsTemplates.manage":
                            case "appLayout.harriSH.access-portal.settings.hrActionsTemplates.create":
                            case "appLayout.harriSH.access-portal.settings.harri-engage":
                            case "appLayout.harriSH.create-event":
                            case "appLayout.harriSH.edit-event":
                            case "appLayout.harriSH.access-portal.settings.create-touchpoint":
                            case "appLayout.harriSH.access-portal.settings.edit-touchpoint":
                            case "appLayout.harriSH.access-portal.settings.social-referral-templates":
                            case "appLayout.harriSH.access-portal.settings.crm":
                            case "appLayout.harriSH.access-portal.settings.interview-invite":
                            case "appLayout.harriSH.access-portal.settings.interview-questions-bank":
                                $scope.activeView = "TEMPLATES";
                                break;


                        }
                    };

                    $scope.isActiveLink = function (link) {
                        return $scope.activeView === link;
                    };

                    $scope.isHmapDashboardView = function () {
                        return $state.current.name === dashboardState;
                    };

                    var isManageCRMAvailable = function () {
                        return $scope.permissions &&
                            $scope.permissions.canManageCRM &&
                            $scope.isHighestParent &&
                            $scope.isEnableCandidateRelationshipManagementEnabled &&
                            $scope.isGlobalTalentPoolServiceEnabled;
                    };

                    var isManageJobTemplatesAvailable = function () {
                        return $scope.activeBrandPolicy &&
                            $scope.activeBrandPolicy.actions &&
                            $scope.activeBrandPolicy.actions[0] === 'ALL' &&
                            $scope.permissions &&
                            $scope.permissions.canManageJobTemplates &&
                            $scope.permissions.hasAccessToSourceHire;
                    };

                    var isMangersNotificationsTemplatesAvailable = function () {
                        return $scope.permissions &&
                            $scope.permissions['canManageManagersNotificationsTemplates'] &&
                            $scope.isManagersNotificationsServiceEnabled &&
                            $scope.isHighestParent
                    }

                    var isManageHRActionsTemplatesAvailable = function () {
                        return $scope.activeBrandPolicy &&
                            $scope.activeBrandPolicy.actions &&
                            $scope.activeBrandPolicy.actions[0] === 'ALL' &&
                            $scope.isHrActionsServiceEnabled &&
                            $scope.permissions &&
                            $scope.permissions.canManageHrActionsTemplates
                    };

                    var isManageHarriEngageTemplatesAvailable = function () {
                        return ($scope.isOnBoardingJourneyServiceEnabled &&
                            $scope.permissions &&
                            $scope.permissions.canManageOnBoardingJourneyTemplates)
                    };

                    const isManageInterviewQuestionsBankAvailable = () => {
                        return $scope?.activeBrandPolicy?.actions?.[0] === 'ALL' &&
                            $scope.isQuestionBankServiceEnabled &&
                            !$scope.isOnBoardingJourneyServiceEnabled &&
                            $scope?.permissions?.canManageInterviewQuestionsBank &&
                            $scope?.permissions?.hasAccessToSourceHire;
                    };

                    $scope.isTemplatesLinkAvailable = function () {
                        return isManageCRMAvailable() || isManageJobTemplatesAvailable() || isManageHRActionsTemplatesAvailable() || isManageHarriEngageTemplatesAvailable() || isManageInterviewQuestionsBankAvailable() || isMangersNotificationsTemplatesAvailable();
                    };

                    $scope.checkIfHighestParent = function () {
                        CoreReaderAPI.getUserBrands(hUser.getUserContext().brand_id, true)
                            .then((userBrands) => {
                                $scope.isHighestParent = userBrands.some(brand => (brand.id === brand.group_id) && (brand.id === $scope.activeBrandId));
                            })
                            .catch((err) => console.error(err));
                    }

                    var brandIds = [];

                    var loadActiveBrandParentIds = function (brandId) {
                        var defer = $q.defer();

                        if (brandId == hUser.getEntryMode().brand_id) {
                            defer.resolve(brandIds);
                            return defer.promise;
                        }

                        brandIds.unshift(brandId);

                        hmapService.loadBrandDetails(brandId)
                            .then(function (brandDetails) {
                                loadActiveBrandParentIds(brandDetails.group_id)
                                    .then(function () {
                                        defer.resolve(brandIds);
                                        return defer.promise;
                                    })
                                    .catch(function (err) {
                                        console.error(err);
                                        defer.reject(err);
                                    });
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });

                        return defer.promise;
                    };

                    var getCurrentUrlParts = function () {
                        var defer = $q.defer();
                        var hmapPath = $stateParams.hmapPath;
                        var brandId = ($stateParams.brandId || $stateParams.brand_id);
                        activeHmapPath = '';

                        if (hmapPath) {
                            var urlParts = (hmapPath && hmapPath.split("-")) || [];
                            defer.resolve(urlParts);
                        } else if (brandId) {
                            loadActiveBrandParentIds(brandId)
                                .then(function (brandIds) {
                                    activeHmapPath = brandIds.join('-');
                                    defer.resolve(brandIds);
                                    return defer.promise;
                                })
                                .catch(function (err) {
                                    console.error(err);
                                    defer.reject(err);
                                });
                        } else {
                            defer.resolve([]);
                        }

                        return defer.promise;
                    };

                    $scope.getTemplatesHref = function () {
                        var routeName = '';
                        let absolute = false;

                        if (isManageJobTemplatesAvailable()) {
                            $scope.templateTrackAutomation = 'accessPortalJobTemplateIcon';
                            routeName = 'appLayout.harriSH.access-portal.settings.jobTemplates';
                        }
                        else if (isManageHRActionsTemplatesAvailable()) {
                            $scope.templateTrackAutomation = '';
                            routeName = 'appLayout.harriSH.access-portal.settings.hrActionsTemplates.manage';
                        }
                        else if (isManageHarriEngageTemplatesAvailable()) {
                            $scope.templateTrackAutomation = 'EngageEngagementSettingsTab';
                            routeName = 'appLayout.harriSH.access-portal.settings.harri-engage';
                        }
                        else if (isMangersNotificationsTemplatesAvailable()) {
                            $scope.templateTrackAutomation = '';
                            routeName = 'appLayout.harriSH.access-portal.settings.managers-notifications';
                        }
                        else if (isManageCRMAvailable()) {
                            $scope.templateTrackAutomation = '';
                            absolute = true
                            routeName = 'appLayout.harriSH.access-portal.settings.crm';
                        }
                        else if (isManageInterviewQuestionsBankAvailable()) {
                            $scope.templateTrackAutomation = '';
                            routeName = 'appLayout.harriSH.access-portal.settings.interview-questions-bank';
                        }

                        return $state.href(routeName, {hmapPath: $stateParams.hmapPath}, {absolute});
                    };

                    $scope.getEntryHref = (url) => {
                        const absolute = $state.current.name === dashboardState
                        return $state.href('.', {
                            hmapPath: url || ''
                        }, {absolute});
                    };

                    //Init
                    (function () {
                        getCurrentUrlParts()
                            .then(function (urlParts) {
                                evalutePath($stateParams.hmapPath, urlParts);
                            })
                            .catch(function (err) {
                                console.error(err);
                            });

                        $scope.checkIfHighestParent();

                        loadPermissions();

                        var promises = {};

                        promises[userServices.SERVICES.QUESTION_BANK] = userServices.isServiceEnabled(userServices.SERVICES.QUESTION_BANK, $scope.activeBrandId);
                        promises[userServices.SERVICES.ON_BOARDING] = userServices.isServiceEnabled(userServices.SERVICES.ON_BOARDING, $scope.activeBrandId, true);
                        promises[userServices.SERVICES.VIDEO_INTERVIEW] = userServices.isServiceEnabled(userServices.SERVICES.VIDEO_INTERVIEW, $scope.activeBrandId);
                        promises[userServices.SERVICES.REASON_TO_SKIP] = userServices.isServiceEnabled(userServices.SERVICES.REASON_TO_SKIP, $scope.activeBrandId);
                        promises[userServices.SERVICES.ATR] = userServices.isServiceEnabled(userServices.SERVICES.ATR, $scope.activeBrandId, true);
                        promises[userServices.SERVICES.JOB_APPROVAL_FLOW] = userServices.isServiceEnabled(userServices.SERVICES.JOB_APPROVAL_FLOW, $scope.activeBrandId);
                        promises[userServices.SERVICES.HR_ACTIONS] = userServices.isServiceEnabled(userServices.SERVICES.HR_ACTIONS, $scope.activeBrandId);
                        promises[userServices.SERVICES.APPROVAL_FLOW] = userServices.isServiceEnabled(userServices.SERVICES.APPROVAL_FLOW, $scope.activeBrandId);
                        promises[userServices.SERVICES.JOB_TITLE_SKILL_LEVEL] = userServices.isServiceEnabled(userServices.SERVICES.JOB_TITLE_SKILL_LEVEL, $scope.activeBrandId);
                        promises[userServices.SERVICES.RAW_DATA_REPORTING] = userServices.isServiceEnabled(userServices.SERVICES.RAW_DATA_REPORTING, $scope.activeBrandId);
                        promises[userServices.SERVICES.EEO_REPORT] = userServices.isServiceEnabled(userServices.SERVICES.EEO_REPORT, $scope.activeBrandId);
                        promises[userServices.SERVICES.SCHEDULE_REPORTS] = userServices.isServiceEnabled(userServices.SERVICES.SCHEDULE_REPORTS, $scope.activeBrandId);
                        promises[userServices.SERVICES.SSO_MCD] = userServices.isServiceEnabled(userServices.SERVICES.SSO_MCD, $scope.activeBrandId);
                        promises['policyParser'] = userPermissions.getBrandPolicy($scope.activeBrandId);
                        promises['GPPolicy'] = hmapService.loadGPPlociy(activeBrandId);
                        promises['hasManageAllScheduledReportsPermission'] = userPermissions.hasPermissionOnBrandOrAnyChild($scope.activeBrandId, userPermissions.PERMISSIONS.MANAGE_ALL_SCHEDULED_REPORTS, userPermissions.PERMISSION_CATEGORIES.HARRI);
                        promises['hasScheduleReportsPermission'] = userPermissions.hasPermissionOnBrandOrAnyChild($scope.activeBrandId, userPermissions.PERMISSIONS.SCHEDULE_REPORTS, userPermissions.PERMISSION_CATEGORIES.HARRI);
                        promises['enabledApprovalFlowsSettings'] = ApprovalFlowAPI.getBrandApprovalFlowSettings($scope.activeBrandId);
                        promises[userServices.SERVICES.TEAM] = userServices.isServiceEnabled(userServices.SERVICES.TEAM, $scope.activeBrandId, true);
                        promises[userServices.SERVICES.HARRI_ENGAGE] = userServices.isServiceEnabled(userServices.SERVICES.HARRI_ENGAGE, $scope.activeBrandId);
                        promises[userServices.SERVICES.ONBOARDING_JOURNEY] = userServices.isServiceEnabled(userServices.SERVICES.ONBOARDING_JOURNEY, $scope.activeBrandId);
                        promises['brandTalentPoolSettings'] = talentPoolDataService.getBrandTalentPoolSettings($scope.activeBrandId);
                        promises[brandServices.SERVICES.GLOBAL_TALENT_POOL] = brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, $scope.activeBrandId);


                        $scope.videoInterviewPermissions = {
                            MANAGE_MEDIA: false,
                            MANAGE_TEMPLATES: false
                        };

                        $q.all(promises)
                            .then(function (result) {
                                $scope.isEnableCandidateRelationshipManagementEnabled = result['brandTalentPoolSettings'] &&
                                    result['brandTalentPoolSettings'].enable_candidate_relationship_management;
                                $scope.isGlobalTalentPoolServiceEnabled = !!result[brandServices.SERVICES.GLOBAL_TALENT_POOL];

                                $scope.isQuestionBankServiceEnabled = !!result[userServices.SERVICES.QUESTION_BANK];
                                $scope.isVideoInterviewServiceEnabled = !!result[userServices.SERVICES.VIDEO_INTERVIEW];
                                $scope.isJobTitleSkillLevelServiceEnabled = !!result[userServices.SERVICES.JOB_TITLE_SKILL_LEVEL];
                                $scope.isOnBoardingServiceEnabled = !!result[userServices.SERVICES.ON_BOARDING];
                                if (!!result[userServices.SERVICES.HARRI_ENGAGE] && result['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_TOUCHPOINTS)) {
                                    HarriEngageServiceAPI.checkBrandLevelActivation($scope.activeBrandId).then(function(levelActivation) {
                                        $scope.isHarriEngageServiceAvaliable = levelActivation.is_level_activated;
                                    });
                                }
                                $scope.isOnBoardingJourneyServiceEnabled = !!result[userServices.SERVICES.ONBOARDING_JOURNEY];
                                $scope.teamlive_location_period_enabled =
                                    result['enabledApprovalFlowsSettings'] &&
                                    result['enabledApprovalFlowsSettings'].settings &&
                                    result['enabledApprovalFlowsSettings'].settings.teamlive_location_period_enabled;
                                $scope.teamlive_position_enabled =
                                    result['enabledApprovalFlowsSettings'] &&
                                    result['enabledApprovalFlowsSettings'].settings &&
                                    result['enabledApprovalFlowsSettings'].settings.teamlive_position_enabled;

                                $scope.isOfferApprovalFlowSettingsEnabled = result['enabledApprovalFlowsSettings']?.settings?.offer_letter_enabled;
                                $scope.isDocumentsApprovalFlowSettingsEnabled = result['enabledApprovalFlowsSettings']?.settings?.documents_enabled;

                                $scope.activeBrandPolicy = _.find(result['GPPolicy'].brands, function (entry) {
                                    return entry.id == activeBrandId;
                                });

                                $scope.isRawDataReportingActivated = !!result[userServices.SERVICES.RAW_DATA_REPORTING];
                                $scope.isEEOServiceEnabled = !!result[userServices.SERVICES.EEO_REPORT];
                                $scope.isScheduleReportsServiceEnabled = !!result[userServices.SERVICES.SCHEDULE_REPORTS];
                                $scope.isSSOMCDServiceEnabled = !!result[userServices.SERVICES.SSO_MCD];
                                $scope.permissions['hasManageAllScheduledReportsPermission'] = result['hasManageAllScheduledReportsPermission'];
                                $scope.permissions['hasScheduleReportsPermission'] = result['hasScheduleReportsPermission'];

                                if ($scope.isVideoInterviewServiceEnabled && $scope.activeBrandPolicy.actions[0] === 'ALL') {
                                    interviewBankDataService.getBrandQuestionBankSettings($scope.activeBrandId, false, interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW)
                                        .then(function (brandSettings) {
                                            $scope.videoInterviewPermissions.MANAGE_MEDIA = result['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_MEDIA) && !brandSettings.is_media_forced;
                                            $scope.videoInterviewPermissions.MANAGE_TEMPLATES = result['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_QUESTION_BANK_VIDEO_INTERVIEW_FIELDS) && !brandSettings.is_forced;
                                            $scope.isVideoInterviewServiceEnabled = (
                                                $scope.isVideoInterviewServiceEnabled &&
                                                (
                                                    $scope.videoInterviewPermissions.MANAGE_MEDIA ||
                                                    $scope.videoInterviewPermissions.MANAGE_TEMPLATES
                                                )
                                            );
                                        })

                                }
                                $scope.reportsExporterTitle = $scope.isScheduleReportsServiceEnabled ?  $filter("translate")('Automated report scheduler') : $filter("translate")('Reports exporter');
                                $scope.isReasonToSkipEnabled = !!result[userServices.SERVICES.REASON_TO_SKIP];
                                $scope.isJobApprovalFlowEnabled = !!result[userServices.SERVICES.JOB_APPROVAL_FLOW] ;
                                var isHrActionsServiceEnabled = !!result[userServices.SERVICES.HR_ACTIONS];
                                var canViewHrActionsTab = result['policyParser'].has(userPermissions.PERMISSIONS.VIEW_HR_ACTIONS);
                                var hasOverrideJobApprovalPermission = result['policyParser'].has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS);
                                var hasHrActionsApprovalsPermission = result['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_HR_ACTIONS_APPROVALS);
                                $scope.canManageHrActionsAprovals = isHrActionsServiceEnabled && canViewHrActionsTab && (hasOverrideJobApprovalPermission || hasHrActionsApprovalsPermission);
                                $scope.isApprovalFlowEnabled =
                                    !!result[userServices.SERVICES.APPROVAL_FLOW] &&
                                    (
                                        (result['policyParser'].has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS)) ||
                                        ($scope.teamlive_position_enabled && result['policyParser'].has(userPermissions.PERMISSIONS.APPROVE_TEAMLIVE_POSITION)) ||
                                        ($scope.teamlive_location_period_enabled && result['policyParser'].has(userPermissions.PERMISSIONS.APPROVE_TEAMLIVE_LOCATION_PERIOD)) ||
                                        ($scope.isOfferApprovalFlowSettingsEnabled && result['policyParser'].hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)) ||
                                        ($scope.isDocumentsApprovalFlowSettingsEnabled && result['policyParser'].hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE))

                                    );
                                var hasManagePayRunsAccess = result['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_PAYSHEET_PAYRUN);

                                if (hasManagePayRunsAccess) {
                                    PerformanceAggregatorAPI.getBrandPayrunsTree($scope.activeBrandId)
                                        .then(function (res) {
                                            $scope.canManagePayRuns = !!_.findWhere(res["payruns_tree"], {brand_id: $scope.activeBrandId});
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                        })
                                        .finally(function () {
                                            $scope.$digest();
                                        });
                                }

                                if (result[userServices.SERVICES.TEAM]) {
                                    BrandAPI.getEntryBrandSettings($scope.activeBrandId)
                                        .then(function (entryBrandSettings) {
                                            $scope.isManagersNotificationsServiceEnabled = entryBrandSettings.enable_core_hr_notifications;
                                            $scope.$digest();
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                            $scope.isManagersNotificationsServiceEnabled = false;
                                        })
                                        .finally(function () {
                                            $scope.$digest();
                                        });
                                }

                                if (result[userServices.SERVICES.ATR] && $scope.activeBrandPolicy.actions[0] === 'ALL') {
                                    $scope.isATRManagementEnabled = result[userServices.SERVICES.ATR];

                                    ATRAPI.getBrandSettings(activeBrandId)
                                        .then(function (atrSettings) {
                                            $scope.isATRManagementEnabled = (["MB", "BNB_WORKDAY"].indexOf(atrSettings.atr_type) > -1);
                                            $scope.$digest();
                                        },function(err){
                                            console.error(err);
                                            $scope.isATRManagementEnabled = false;
                                            $scope.$digest();
                                        });
                                }
                            });

                    }());
                }
            };
        }]);
})();
